// extracted by mini-css-extract-plugin
export default {"tags-inplace-edit":"TagsInplaceEditWithAutoComplete_tags-inplace-edit__z0itV"};